import tutorialsSaga from './tutorialsSaga';
import firmwareSaga from './firmwareSaga';

export default [tutorialsSaga, firmwareSaga].flat();
